import React, { FunctionComponent } from 'react';

import styled, { useTheme } from 'styled-components';

import { Translate } from 'react-localize-redux';

import SimpleArtist from '@common/types/artist/simple-artist';

import Flex from '@components/layout/flex';
import Avatar from '@components/basics/avatar';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import CircleArrowIcon from '@components/basics/icons/circle-arrow';

interface AvatarHeaderProps {
  className?: string;
  artist: SimpleArtist;
  numberOfNotifications: number;
  noNotifications: boolean;
  artistNotificationOpen: string;
  setArtistNotificationOpen: React.Dispatch<React.SetStateAction<string>>;
  HandleClearAll: () => void;
}

const AvatarHeader: FunctionComponent<AvatarHeaderProps> = ({
  className,
  artist,
  numberOfNotifications,
  artistNotificationOpen,
  noNotifications,
  HandleClearAll,
  setArtistNotificationOpen,
}) => {
  const theme = useTheme();
  return (
    artist && (
      <div className={className || ''}>
        <Flex
          className="mb-30"
          justifyContent="space-between"
          alignItems="center"
        >
          <Flex alignItems="center" gap={10}>
            <Avatar src={artist?.avatar} alt={artist?.name} />
            <Flex alignItems="baseline" gap={5}>
              <Typography weight="600">{artist?.name}</Typography>
              <Typography weight="600" color={theme.colors.tertiary}>
                ({numberOfNotifications})
              </Typography>
            </Flex>
          </Flex>
          <Flex justifyContent="flex-end" alignItems="center" gap={20}>
            {artistNotificationOpen === artist.name && (
              <MotionOpacity>
                <Link
                  className={noNotifications ? 'disabled' : ''}
                  weight="700"
                  onClick={noNotifications ? undefined : HandleClearAll}
                >
                  <Translate id="NOTIFICATIONS.CLEAR_ALL" />
                </Link>
              </MotionOpacity>
            )}
            <ArrowIcon
              className={noNotifications ? 'disabled' : ''}
              size="32px"
              smallArrow
              onClick={() =>
                setArtistNotificationOpen(
                  artistNotificationOpen === artist.name ? '' : artist.name
                )
              }
              arrowUp={artistNotificationOpen === artist.name}
            />
          </Flex>
        </Flex>
      </div>
    )
  );
};

export default AvatarHeader;

export const Link = styled(Typography)`
  cursor: pointer;
  text-align: right;
  color: ${({ theme }) => theme.colors.tertiary};
  transition: color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &.disabled {
    pointer-events: none;
  }

  &:not(.disabled) {
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const ArrowIcon = styled(CircleArrowIcon)`
  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
`;
